/*
 * Copyright (c) 2023. Collabro Limited
 */

import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface SessionDialogProps {
  open: boolean;
  handleClose: any;
}

const SessionDialog = (props: SessionDialogProps) => {
  return (
    <Dialog open={props.open} onClose={props.handleClose}>
      <DialogTitle>Session Expired</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Session has expired. Please login again.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} autoFocus>
          Login
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionDialog;
